import $api from "@/frontend/shared/api/axios";

export function postLogout() {
  return $api.post("/auth/logout");
}
